export default "__VITE_ASSET__EJvi82U$__"